/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.59"
        height="95.33"
        viewBox="0 0 95.59 95.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M55.69 58.16 3.25 27.07l3.4-5.73 42.72 25.32Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M50.02 46 6.34 20.14l-4.29 7.24 55.94 33.16ZM6.95 22.53l41.77 24.76 4.66 8.5-48.94-29Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="m49.2 29.92.3-.12c3.22-1.33 6.67-.45 9.86 3.4l.23.28 17.58 22.05a1.24 1.24 0 0 1-.1 1.76 1.25 1.25 0 0 1-1.77-.1l-.09-.1L57.63 35c-2.5-3.13-4.79-3.82-7-3l-.19.07a6.18 6.18 0 0 0-3.25 2.79 5.61 5.61 0 0 0 0 4.61l.16.4.18.41.37.76.6 1.36 1.24 2.36 1.06 2 2 3.65.25.45L54.22 53l7.06 12.93.28.57.11.21a10.37 10.37 0 0 1 1 4.9v2.46a23.51 23.51 0 0 0 .11 4.89c.73 4.17 1.72 6.82 3.7 9.42a18 18 0 0 0 5.5 4.6 1.23 1.23 0 0 1 .52 1.67 1.25 1.25 0 0 1-1.69.51 20.44 20.44 0 0 1-6.29-5.26c-2.27-3-3.39-6-4.2-10.58a26.64 26.64 0 0 1-.14-5.43v-3.1a7.27 7.27 0 0 0-.67-2.75l-.12-.25-.35-.7-6.74-12.37-3.8-7-1.61-3-.77-1.49-.44-.86-.4-.82-.15-.33-.12-.27v-.16a8.17 8.17 0 0 1 0-7 8.63 8.63 0 0 1 4.19-3.87Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M15.73 3.35A6.88 6.88 0 0 1 24.9.83l.21.12 42.8 25.37a6.85 6.85 0 0 1 2.52 9.13l-.12.22-4.24 7.17a1.25 1.25 0 0 1-2.21-1.15l.06-.13 4.23-7.16a4.34 4.34 0 0 0-1.34-5.82l-.18-.11L23.84 3.11a4.37 4.37 0 0 0-5.85 1.33l-.11.19-14.78 25a4.34 4.34 0 0 0 1.34 5.82l.19.12 42.79 25.32a4.26 4.26 0 0 0 2.19.61 4.43 4.43 0 0 0 1.1-.16 4.22 4.22 0 0 0 2.54-1.8l.12-.19 1.13-1.87a1.26 1.26 0 0 1 1.72-.43 1.25 1.25 0 0 1 .49 1.59l-.06.12-1.15 1.87a6.76 6.76 0 0 1-4.18 3.13 7 7 0 0 1-1.71.24 6.84 6.84 0 0 1-3.22-.81l-.25-.19L3.35 37.68a6.87 6.87 0 0 1-2.53-9.15l.13-.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M67.04 36.32a1.26 1.26 0 0 1 1.6-.77l12.09 4.24c4.29 1.6 5.78 3.39 6.65 7.29l.12.57.3 1.64 5.43 28.9 2.35 12.6a1.21 1.21 0 0 1-1 1.44 1.25 1.25 0 0 1-1.46-1L88.4 65.85l-2.72-14.46-.37-1.93-.18-1-.11-.52-.11-.49c-.64-2.78-1.6-3.9-4.5-5.06l-.51-.2-12.07-4.3a1.26 1.26 0 0 1-.77-1.59ZM48.09 61.61a1.25 1.25 0 0 1 1.65.25l.08.11 3.25 4.91a6 6 0 0 0 3.07 2.34l5.63 1.87a1.25 1.25 0 0 1-.7 2.4h-.09l-5.63-1.86a8.64 8.64 0 0 1-4.17-3.06l-.19-.28-3.25-4.91a1.26 1.26 0 0 1 .35-1.74Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'HandHoldingCreditCardIcon';

export default Icon;
